/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { StyleSheet, View, ScrollView, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import { isWeb, fullWidth, fullHeight } from '@global/screens';
import Colors from '@global/colors';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import FileInput from '@components/form/FileInput';
import SociollaText from '@components/sociolla/SociollaText';

import { MsCatalog } from '@api/ms-catalog';
import { showPopup } from '@/store/modal';

const DEFAULT_PAYLOAD = {
  url: '',
  description: '',
};

const TABS = [
  { label: '1 column', value: 1 },
  { label: '2 column', value: 2 },
  { label: '3 column', value: 3 },
];

const TAB_ONE = [DEFAULT_PAYLOAD];
const TAB_TWO = [DEFAULT_PAYLOAD, DEFAULT_PAYLOAD];
const TAB_THREE = [DEFAULT_PAYLOAD, DEFAULT_PAYLOAD, DEFAULT_PAYLOAD];

const submitStyle = {
  ...(isWeb
    ? {
        width: isWeb ? 'calc(100% - 30px)' : fullWidth - 30,
      }
    : { width: fullWidth - 30 }),
  marginHorizontal: 15,
};

const ImageSectionForm = ({
  updateInitImages,
  id,
  sectionId = '',
  editData = null,
  show,
  onClose,
  onSubmit,
}) => {
  const dispatch = useDispatch();
  const [payload, setPayload] = useState({
    image_column: 1,
    image: TAB_ONE,
  });

  useEffect(() => {
    let mounted = true;
    if (mounted && show) {
      setPayload({
        image_column: editData?.length ? editData.length : 1,
        image: editData ? editData : TAB_ONE,
      });
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  const isDisabledSubmit = () => {
    let result = false;

    if (payload?.image?.length) {
      for (let i = 0; i < payload.image.length; i++) {
        const item = payload.image[i];
        if (!item?.url || !item.description) {
          result = true;
        }
      }
    } else {
      result = true;
    }

    return result;
  };

  const onSubmitForm = async () => {
    const body = {
      image_column: payload.image_column,
      image: payload.image,
    };

    if (!id) {
      updateInitImages('images', { ...body }, false);
      onClose();
      return;
    }

    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const response = await MsCatalog.updateCMSSection(
        id,
        'images',
        sectionId,
        body,
      );
      if (response?.data?.data?._id || response?.data?.success) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        onSubmit();
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const addNewForm = (payload) => {
    const newPayload = {
      ...payload,
      type: 'images',
    };
    updateInitImages('images', newPayload, true);
    onClose();
  };

  return (
    <ModalFull
      title="Add Image Section"
      show={show}
      back={isWeb ? false : true}
      width={isWeb ? 350 : '100%'}
      onClose={() => onClose()}>
      <ScrollView
        style={{ width: '100%', maxHeight: fullHeight - (isWeb ? 140 : 55) }}>
        <View style={{ width: '100%', padding: isWeb ? 15 : 20 }}>
          <View style={styles.columnForm}>
            {TABS.map((item, idx) => (
              <TouchableOpacity
                key={idx}
                style={[
                  styles.columnItem,
                  item.value == payload.image_column
                    ? {
                        backgroundColor: Colors.blue5,
                        borderColor: Colors.blue0,
                      }
                    : {},
                ]}
                activeOpacity={0.8}
                onPress={() => {
                  setPayload({
                    image_column: item.value,
                    image:
                      item.value == 1
                        ? TAB_ONE
                        : item.value == 2
                        ? TAB_TWO
                        : TAB_THREE,
                  });
                }}>
                <View style={styles.boxWrapper}>
                  {[1, 2, 3].includes(item.value) ? (
                    <View
                      style={[
                        styles.box,
                        item.value == 1
                          ? styles.widthOne
                          : item.value == 2
                          ? styles.widthTwo
                          : styles.widthThree,
                      ]}
                    />
                  ) : (
                    false
                  )}
                  {[2, 3].includes(item.value) ? (
                    <View
                      style={[
                        styles.box,
                        item.value == 2 ? styles.widthTwo : styles.widthThree,
                      ]}
                    />
                  ) : (
                    false
                  )}
                  {item.value == 3 ? (
                    <View style={[styles.box, styles.widthThree]} />
                  ) : (
                    false
                  )}
                </View>
                <SociollaText style={{ textAlign: 'center' }}>
                  {item.label}
                </SociollaText>
              </TouchableOpacity>
            ))}
          </View>
          <View>
            {payload.image.map((item, idx) => (
              <View key={idx}>
                <View style={styles.formSpace}>
                  <FileInput
                    label={`Image ${idx + 1}`}
                    value={item.url}
                    isRequired
                    isImage
                    onChange={(value) => {
                      const old = JSON.parse(JSON.stringify(payload));
                      old.image[idx].url = value;
                      setPayload(old);
                    }}
                  />
                </View>
                <View style={styles.formSpace}>
                  <Input
                    label="Description"
                    value={item.description}
                    isRequired={true}
                    onChangeText={(value) => {
                      const old = JSON.parse(JSON.stringify(payload));
                      old.image[idx].description = value;
                      setPayload(old);
                    }}
                  />
                </View>
              </View>
            ))}
          </View>
        </View>
        <View
          style={{
            width: '100%',
            paddingVertical: 15,
            justifyContent: 'center',
            borderTopColor: isWeb ? 'transparent' : Colors.grey0,
            borderTopWidth: 1,
          }}>
          <Button
            rounded={true}
            buttonStyle={submitStyle}
            disabledStyle={submitStyle}
            disabled={isDisabledSubmit()}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: 14,
                  letterSpacing: 0.5,
                  color: Colors.white,
                }}>
                Add
              </SociollaText>
            }
            onPress={() => {
              editData ? onSubmitForm() : addNewForm(payload);
            }}
          />
        </View>
      </ScrollView>
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  formSpace: { marginBottom: 10 },
  columnForm: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  columnItem: {
    width: isWeb ? 'calc((100% / 3) - 5px)' : (fullWidth - 30) / 3 - 5,
    backgroundColor: Colors.grey0,
    borderColor: Colors.grey0,
    borderWidth: 1,
    borderRadius: 5,
    paddingHorizontal: 5,
    paddingVertical: 16,
    justifyContent: 'center',
  },
  boxWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
  },
  box: {
    backgroundColor: Colors.blue1,
    borderRadius: 5,
    height: 25,
    marginHorizontal: 2,
  },
  widthOne: { width: 60 },
  widthTwo: { width: 30 },
  widthThree: { width: 20 },
});

export default ImageSectionForm;
